import { createSelector } from 'reselect';
const resellerHomePageRootSelectors = state => state.resellerHomePage;
export const categoriesSelector = createSelector(resellerHomePageRootSelectors, state => state.categories);
export const promoProductsSelector = createSelector(resellerHomePageRootSelectors, state => state.promoProducts);